import { useLang } from "../i18n";
import { Sparkle } from "lucide-react";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div className="border-y-2 border-topacio-ink bg-brand overflow-hidden py-5" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-4 px-10 text-lg md:text-2xl uppercase tracking-wide text-topacio-ink font-display font-black">
            {item}
            <Sparkle className="w-5 h-5 text-topacio-red" strokeWidth={2.5} fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}
